import {ControlActions, ControlActionTypes} from '@/store/action/control'


// 默认状态
const initialState = {
    isShowLoginModal: false,
    isShowRecharge: false,
    isShowShare: false,
    isShowRechargeQrcode: false,
    rechargeQrcode: '',
    rechargeOrderId: '',
    loginTitleTextArray: [
        '登录SoraAI来继续使用'
    ]
}

/**
 * 控制查询结果的reducer
 * @param {*} state
 * @param {*} action
 */
export function controls(state = initialState, {type, payload}: {
    type: ControlActionTypes, payload: ControlActions['payload']
}): typeof initialState {
    switch (type) {
        case ControlActionTypes.InitShowLoginModal:
            state.isShowLoginModal = payload as boolean
            break;
        case ControlActionTypes.InitShowRechargeModal:
            state.isShowRecharge = payload as boolean;
            break;
        case ControlActionTypes.InitLoginTitleTextArray:
            state.loginTitleTextArray = payload as string[];
            break;
        case ControlActionTypes.InitShowShare:
            state.isShowShare = payload as boolean;
            break;
        case ControlActionTypes.InitShowRechargeQrcode:
            state.isShowRechargeQrcode = payload as boolean;
            break;
        case ControlActionTypes.InitRechargeQrcode:
            state.rechargeQrcode = payload as string;
            break;
            case ControlActionTypes.InitRechargeOrderId:
            state.rechargeOrderId = payload as string;
            break;
    }
    return {
        ...state
    };
}
